var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconReorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.reorder{fill:currentColor;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "reorder",
    d: "M1.75,4.52h12.5c0.41,0,0.75-0.34,0.75-0.75s-0.34-0.75-0.75-0.75H1.75C1.34,3.02,1,3.35,1,3.77 S1.34,4.52,1.75,4.52z M14.25,7.27H1.75C1.34,7.27,1,7.6,1,8.02c0,0.42,0.34,0.75,0.75,0.75h12.5c0.41,0,0.75-0.34,0.75-0.75 C15,7.61,14.66,7.27,14.25,7.27z M14.25,11.52H1.75C1.34,11.52,1,11.85,1,12.27s0.34,0.75,0.75,0.75h12.5 c0.41,0,0.75-0.34,0.75-0.75S14.66,11.52,14.25,11.52z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReorder);
export default __webpack_public_path__ + "static/media/icon_reorder.c582780e899620b9fa8dc8d9fc8ad093.svg";
export { ForwardRef as ReactComponent };